<template>
  <b-overlay :show="show" opacity="1" no-center :style="show ? { minHeight: height + 'px' } : null">
    <template #overlay>
      <GlobeLoader
        :style="{ height: height + 'px' }"
        title="KPIs werden geladen"
        subtitle="Einen Moment, die Kennzahlen werden berechnet"
      />
    </template>
    <slot />
  </b-overlay>
</template>

<script>
import GlobeLoader from '@/components/common/globe-loader.vue';

// Lade-Overlay der KPI-Seiten, der Lader wird in der sichtbaren Höhe zentriert
export default {
  name: 'KpiLoadingOverlay',
  components: { GlobeLoader },
  props: {
    show: { type: Boolean, default: false },
    height: { type: Number, required: true },
  },
};
</script>
